import HandDislikeIcon from "./HandDislikeIcon.mjs";

/** @type {GlyphIcon} */
export default HandDislikeIcon;